var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('TopTab'),_c('div',{staticClass:"container"},[_c('router-view')],1),_c('BottomFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }